<template>
  <div>
    <h1>Signing in...</h1>
  </div>
</template>

<script>
import { authService } from '@/js/authentication/authentication'

export default {
  mounted() {
    authService.signinSilentCallback()
  },
}
</script>